var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_287672339592341087062826612122566938534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 16,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3368 23.206H15.608C14.7212 23.206 13.8617 23.0405 13.0646 22.7347L12.5956 25.7913C12.5384 26.164 12.8269 26.5 13.204 26.5H18.7408C19.1179 26.5 19.4063 26.164 19.3491 25.7913L18.8801 22.7347C18.083 23.0406 17.2235 23.206 16.3368 23.206Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8049 18.0529H10.1397C10.1114 18.0529 10.0834 18.0518 10.0554 18.0508C10.8642 20.3371 13.0446 21.9751 15.6079 21.9751H16.3366C18.9 21.9751 21.0803 20.3371 21.8891 18.0508C21.8611 18.0517 21.8331 18.0529 21.8049 18.0529Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4028 8.15828H21.5108C21.603 6.73089 20.4694 5.5 19.0158 5.5H12.9287C11.4182 5.5 10.2525 6.82899 10.4495 8.32662L11.0999 13.2717H20.8445L21.3552 9.38921H22.4027C22.7426 9.38921 23.0182 9.11365 23.0182 8.77376C23.0182 8.43383 22.7427 8.15828 22.4028 8.15828Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8049 16.8221H10.1397C9.49921 16.8221 8.97998 16.3028 8.97998 15.6623C8.97998 15.0218 9.49921 14.5026 10.1397 14.5026H21.8049C22.4454 14.5026 22.9646 15.0218 22.9646 15.6623C22.9646 16.3028 22.4454 16.8221 21.8049 16.8221Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_287672339592341087062826612122566938534)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#hinava_random_uuid_183921355623511226806909917569761164545)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_183921355623511226806909917569761164545",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWc);
export default __webpack_public_path__ + "static/media/wc.e4d089fa568126f9514d7af96334244e.svg";
export { ForwardRef as ReactComponent };